export const token = localStorage.getItem("token");
export const configHeaders = {
  headers: {
    Authorization: `Bearer ${token}`,
  },
};

const bugzillaToken = localStorage.getItem("bugzillaToken");

export const configHeadersBugzilla = {
  headers: {
    Authorization: `Bearer ${bugzillaToken}`,
  },
};

export const isUATServer = false;

export const phoneNumber = +918331889448;

// export const serverUrl = "http://localhost:4000/api";
export const serverUrl = "https://nexgenwebdesignsbackend.onrender.com/api";
